import React from "react";

const ZoomIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_968)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_2785_968)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40 20C40 22.14 39.83 24.24 39.5 26.28C38.41 33.05 33.05 38.41 26.28 39.5C24.24 39.83 22.14 40 20 40C17.86 40 15.76 39.83 13.72 39.5C6.95 38.41 1.59 33.05 0.5 26.28C0.17 24.24 0 22.14 0 20C0 17.86 0.17 15.76 0.5 13.72C1.59 6.95 6.95 1.59 13.72 0.5C15.76 0.17 17.86 0 20 0C22.14 0 24.24 0.17 26.28 0.5C33.05 1.59 38.41 6.95 39.5 13.72C39.83 15.76 40 17.86 40 20Z",
  fill: "#0B5CFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 20C40 22.14 39.83 24.24 39.5 26.28C38.41 33.05 33.05 38.41 26.28 39.5C24.24 39.83 22.14 40 20 40C17.86 40 15.76 39.83 13.72 39.5C6.95 38.41 1.59 33.05 0.5 26.28C0.17 24.24 0 22.14 0 20C0 17.86 0.17 15.76 0.5 13.72C1.59 6.95 6.95 1.59 13.72 0.5C15.76 0.17 17.86 0 20 0C22.14 0 24.24 0.17 26.28 0.5C33.05 1.59 38.41 6.95 39.5 13.72C39.83 15.76 40 17.86 40 20Z",
  fill: "url(#paint0_radial_2785_968)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40 20C40 22.14 39.83 24.24 39.5 26.28C38.41 33.05 33.05 38.41 26.28 39.5C24.24 39.83 22.14 40 20 40C17.86 40 15.76 39.83 13.72 39.5C6.95 38.41 1.59 33.05 0.5 26.28C0.17 24.24 0 22.14 0 20C0 17.86 0.17 15.76 0.5 13.72C1.59 6.95 6.95 1.59 13.72 0.5C15.76 0.17 17.86 0 20 0C22.14 0 24.24 0.17 26.28 0.5C33.05 1.59 38.41 6.95 39.5 13.72C39.83 15.76 40 17.86 40 20Z",
  fill: "url(#paint1_radial_2785_968)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.2899 25C24.2899 26.18 23.3299 27.14 22.1499 27.14H12.8599C10.4899 27.14 8.56995 25.22 8.56995 22.85V14.99C8.56995 13.81 9.52995 12.85 10.7099 12.85H19.9999C22.3699 12.85 24.2899 14.77 24.2899 17.14V25ZM29.7199 14.14L26.5799 16.5C26.0399 16.9 25.7199 17.54 25.7199 18.21V21.78C25.7199 22.45 26.0399 23.09 26.5799 23.49L29.7199 25.85C30.4299 26.38 31.4299 25.88 31.4299 24.99V15C31.4299 14.12 30.4199 13.61 29.7199 14.14Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_2785_968",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.1 17.6488) scale(26.77 22.4868)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#0B5CFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.98,
  stopColor: "#003CB3"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_2785_968",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.07 23.728) scale(26.02 23.9384)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#0B5CFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3386FF"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_968"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_2785_968"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ZoomIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;